import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
  setUsers: createAction("setUsers"),
  setTrash: createAction("setTrash"),
  setWallets: createAction("setWallets"),
  setHistories: createAction("setHistories"),
  setMyUser: createAction("setMyUser"),
};

export default actionTypes;
